import React from 'react'

import {createSvgIcon} from './utils'

export default createSvgIcon(
  <>
    <circle cx="12" cy="12" r="10" />
    <path d="M8 8L16.5 16.5M16.5 8L8 16.5" stroke="white" strokeWidth="2" />
  </>,
  'CrossInvert',
)
